import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import { _home_mini_slideshow } from "../../constants/home_mini_slideshow";

function HomeMiniSlideshow() {
  const [slideshows, setSlideshows] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef(null);

  useEffect(() => {
    setSlideshows(_home_mini_slideshow);
  }, []);

  useEffect(() => {
    // Force the slider to show the first slide when it mounts
    if (sliderRef.current) {
      setTimeout(() => {
        sliderRef.current.slickGoTo(0);
      }, 100);
    }
  }, [slideshows]); // Ensure this runs when slideshows are updated

  const settings = {
    dots: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0, // Changed from 1 to 0
    autoplay: false,
    arrows: false,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
    dotsClass: "slick-dots custom-dots",
    appendDots: (dots) => (
      <ul
        key={currentSlide}
        style={{
          margin: 0,
          padding: 0,
          position: "absolute",
          bottom: "-40px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          listStyle: "none",
        }}
      >
        {dots}
      </ul>
    ),
    customPaging: (i) => {
      const isActive = i === currentSlide;
      return (
        <div
          style={{
            width: "15px",
            height: "15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span
            style={{
              width: isActive ? "15px" : "10px",
              height: isActive ? "15px" : "10px",
              border: "1px solid black",
              borderRadius: "50%",
              backgroundColor: isActive ? "transparent" : "black",
              transition: "all 0.3s ease",
            }}
          ></span>
        </div>
      );
    },
    responsive: [
      {
        // For screens below 1200px
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        // For screens below 768px
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="py-11 pt-lg-13 pb-lg-15" style={{ position: "relative" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <Slider ref={sliderRef} {...settings}>
          {slideshows.map((slide, index) => (
            <div key={index}>
              <div style={{ margin: "0 10px" }}>
                <div style={{ position: "relative", width: "100%" }}>
                  {/* Example: 1:1 ratio container */}
                  <div style={{ paddingTop: "100%", position: "relative" }}>
                    <img
                      src={slide.image_url}
                      alt={slide.title}
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  {/* Optional overlay or text */}
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "center",
                      color: "#fff",
                    }}
                  >
                    <button 
                      type="button" 
                      className="btn btn-outline-primary" 
                      style={{
                        marginBottom: "40px"
                      }}
                    >
                      {slide.title}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}

export default HomeMiniSlideshow;